import { CatalogConfigState } from ".";
const getters = {
    selectedFilters: (state:CatalogConfigState) => state.selectedFilters,
};

export default getters;